<template>
  <CCard class="dataTable py-5 mt-3">
    <CRow class="pt-none pb-4">
      <CCol sm="12" class="d-flex flex-column">
        <div>
          <h2 class="titlePage font-weight-normal text-capitalize">{{ $t('organizationSelect.titlePage') }}</h2>
        </div>
        <div class="mt-3">
          <h5 class="titlePage font-weight-normal text-capitalize">{{ $t('organizationSelect.text1') }}</h5>
          <h5 class="titlePage font-weight-normal text-capitalize"></h5>
        </div>
      </CCol>
    </CRow>
    <CCardHeader class="dataTable__header d-flex justify-content-between px-0 pb-5" style="border: none">
      <div class="dataTable__search">
        <CInput
          type="search"
          :placeholder="$t('organizationSelect.input-search-placeholder')"
          addInputClasses="pl-5"
          class="iconSearchPlaceholder pb-0"
          v-model="tableFilterValue"
          @input="searchByName()"
        >
        </CInput>
      </div>
      <div class="dataTable__buttonLink">
        <CButton v-if="canUserCreateOrganization" class="btn btn-primary px-4 font-weight-bold" @click.stop="redirectToCreateOrganization">{{
          $t('organizationSelect.btn.create-new')
        }}</CButton>
      </div>
    </CCardHeader>

    <CCardBody class="dataTable__body p-0">
      <CDataTable
        header
        :items="registers"
        :fields="headers"
        :table-filter="{ external: true, lazy: true }"
        :table-filter-value.sync="tableFilterValue"
        items-per-page-select
        @row-clicked="(row) => selectRow(row.organizationId, 'home')"
        :items-per-page.sync="itemsPerPage"
        @pagination-change="paginationChange"
        :active-page="1"
        hover
        :loading="loading"
      >
        <template #planName="{ item }">
          <td class="text-uppercase">
            {{ $t(`general.plans.${item.planName.toLowerCase()}`) }}
          </td>
        </template>

        <template #createdDateTime="{ item }">
          <td class="text-right">
            {{ formatDate(item.createdDateTime).replace(',', '') }}
          </td>
        </template>
      </CDataTable>
    </CCardBody>

    <div class="position-relative w-100">
      <CPagination
        align="center"
        v-show="totalPages > 0"
        class="text-gray-800 m-0"
        color="text-gray-800"
        :doubleArrows="true"
        :pages="totalPages"
        :active-page.sync="activePage"
        ref="pagination"
      >
        <template slot="previous-button">
          <span class="d-flex content-center">
            <i class="icon fas fa-angle-left font-weight-light mx-2"></i>
            <span>
              {{ $t('general.components.table.pagination.prev') }}
            </span>
          </span>
        </template>

        <template slot="next-button">
          <span class="d-flex content-center">
            <span>
              {{ $t('general.components.table.pagination.next') }}
            </span>
            <i class="icon fas fa-angle-right font-weight-light mx-2"></i>
          </span>
        </template>

        <template slot="first-button">
          <span class="d-flex content-center"> {{ $t('general.components.table.pagination.first') }} </span>
        </template>

        <template slot="last-button">
          <span class="d-flex content-center">
            {{ $t('general.components.table.pagination.last') }}
          </span>
        </template>
      </CPagination>
      <CElementCover v-if="loading" :opacity="0.8" style="z-index: 1001">
        <div></div>
      </CElementCover>
    </div>

    <!-- <CPagination v-show="pages > 0 && totalRecords > 0" align="center" :pages="pages" :active-page.sync="activePage" class="dataTable__newPagination">
      <template slot="previous-button">
        <span class="newPagination__button p-2 btnPagination">
          {{ $t('audience.audienceList.text.prev') }}
        </span>
      </template>
      <template slot="next-button">
        <span class="newPagination__button p-2 btnPagination">
          {{ $t('audience.audienceList.text.next') }}
        </span>
      </template>
    </CPagination> -->
  </CCard>
</template>

<script>
import services from '@/services'
import { dateFormatString } from '@/utils/dateUtil'

const planTypeEnum = {
  1: 'FREE',
  2: 'PROFESSIONAL',
  3: 'CUSTOM',
  4: 'CORPORATE',
}

export default {
  name: 'OrganizationSelection',
  data() {
    return {
      tableFilterValue: null,
      registers: [],
      headers: [
        { key: 'companyName', label: this.$t('organizationSelect.table.header.companyName') },
        { key: 'planName', label: this.$t('organizationSelect.table.header.planType') },
        { key: 'createdDateTime', label: this.$t('organizationSelect.table.header.created'), _classes: 'text-right' },
      ],
      itemsPerPage: 10,
      loading: false,
      totalPages: 0,
      activePage: 1,
      totalRecords: 0,
      searchTimeout: null,
      firstRequest: true,
      pagination: {},
      canUserCreateOrganization: false,
    }
  },
  methods: {
    formatDate(date) {
      return dateFormatString(date)
    },
    // planTypeHandler(planType) {
    //   return planTypeEnum[planType] || 'INVALID'
    // },

    paginationChange(a) {
      this.itemsPerPage = a
    },

    searchByName() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.getData(true)
      }, 1500)
    },

    getData(isSearch) {
      this.loading = true
      let userId = this.$store.state.auth.user.id
      let whitelabelOrganizationId = null

      // Filtro para quando estiver em um subdomínio de uma organização whitelabel
      if (this.$store.getters['whitelabel/isWhitelabel']) {
        whitelabelOrganizationId = this.$store.state.whitelabel.whitelabelConfig.id
      }

      services
        .getUserOrganizations(userId, true, this.activePage, this.itemsPerPage, this.tableFilterValue, whitelabelOrganizationId)
        .then((res) => {
          let list = res.data.data.items
          let pagination = res.data.data.pageOptionsResponse

          if (Array.isArray(list)) {
            if (pagination.totalRecords === 1 && !isSearch) {
              this.$store.dispatch('auth/selectOrganization', { value: list[0].organizationId }).then(() => {
                this.$store.commit('SHOW_BASE_MENU')
                this.$router.push({ name: 'home', params: { organizationId: list[0].organizationId } })
              })
            } else {
              if (list.length === 0 && this.firstRequest) {
                this.$router.push({ name: 'NoOrganization' })
              }

              this.registers = list
              this.totalPages = Math.ceil(pagination.totalRecords / 10)
              this.totalRecords = pagination.totalRecords
              this.activePage = pagination.currentPage
              this.pagination = pagination
            }
          }
        })
        .finally(() => {
          this.loading = false
          this.firstRequest = false
        })
    },

    canCreateOrganization() {
      let userId = this.$store.state.auth.user.id
      services.canCreateOrganization(userId).then((res) => {
        this.canUserCreateOrganization = res.data.data
      })
    },

    selectRow(organizationId, redirectRouteName) {
      this.$store.commit('auth/RESET_ORGANIZATION_PLAN_STATUS')

      this.$store.dispatch('auth/selectOrganization', { value: organizationId }).then(() => {
        this.$store.commit('SHOW_BASE_MENU')
        return this.$router.push({ name: redirectRouteName, params: { organizationId: organizationId } })
      })
    },

    redirectToCreateOrganization() {
      const organizationId = this.registers[0].organizationId
      const redirectRouteName = 'createOrganization'

      this.selectRow(organizationId, redirectRouteName)
    },
  },
  watch: {
    reloadParams() {
      this.getData()
    },
  },
  computed: {
    detailPagination() {
      const first = (this.activePage - 1) * this.itemsPerPage
      const totalPage = this.activePage * 10 > this.totalRecords ? this.totalRecords : this.activePage * 10
      return `${first}  of ${totalPage}`
    },
    reloadParams() {
      return [this.activePage, this.itemsPerPage]
    },
  },
  beforeCreate() {
    this.$store.commit('HIDE_BASE_MENU', 'OrganizationSelection')
    this.$store.commit('SHOW_BASE_USER_CONTROLS')
  },
  mounted() {
    this.canCreateOrganization()
    this.getData()
  },
}
</script>

<style module>
.blockClick {
  pointer-events: none;
}
</style>
